import { $ } from '../util/DOM';

const initMenuFX = () => {
  const buttons = $('[aria-haspopup="true"]');

  const targets = buttons.map((btn) => {
    const target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) {
      return null;
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      const groupName = btn.getAttribute('data-group-name');
      if (groupName) {
        $(`[data-group-name="${groupName}"]`).forEach((b) => {
          b.setAttribute('aria-expanded', false);
        });
      }
      btn.setAttribute('aria-expanded', !isOpen);
    });

    return target;
  }).filter((el) => !!el);

  window.addEventListener('click', ({ target }) => {
    const foundTarget = targets.find((el) => el === target || el.contains(target));
    if (foundTarget) {
      return;
    }
    buttons.forEach((button) => button.setAttribute('aria-expanded', false));
  });
};

export default initMenuFX;
